// getters
export const GET_ALL = 'realms/GET_ALL'
export const GET_CURRENT = 'realms/GET_CURRENT'
// mutations
export const SET_ALL = 'realms/SET_ALL'
export const SET_CURRENT = 'realms/SET_CURRENT'
